import React from 'react';
import Modal from 'react-modal';
import Cookies from 'js-cookie';
import IntegrationReactSelectNew from './IntegrationReactSelectNew';
import InputBox from './InputBox';
import _ from 'lodash';


import '../css/SystemIntegratorAdd.css';
import ErrorText from '../ErrorText';
import cities from './cities';
import Loader from './Loader';
import SnackBar from './SnackBar';


// system integrator page to add new system integrator page

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    minHeight: '50%',
    maxHeight: '90%',
    overflow: 'auto',
    padding: '40px 90px 40px 90px',
    marginLeft: '260px',
    marginTop: '3%',
    backgroundColor: '#EFF3F6',
    // background: 'none !important'
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none"
  },
};


const customStylesSuccess = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    minHeight: '50%',
    maxHeight: '90%',
    overflow: 'auto',
    padding: '40px 90px 40px 90px',
    marginLeft: '260px',
    marginTop: '3%',
    background: '#EFF3F6',
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none"
  },
};

const SiRating = [
  { label: 'A++' },
  { label: 'A' },
  { label: 'B+' },
];

const SiRelationStat = [
  { label: 'Hot' },
  { label: 'Warm' },
  { label: 'Dry' },
  { label: 'Cold' },
];


export default class SystemIntegratorAddNew extends React.Component{
  constructor(props) {
  super(props);

  this.state = {
    modalIsOpen: this.props.activeModal,
    modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
    modalStateAftereOpenSuccess: 'animated animated-duration-custom slideInDown',
    noOfParams: [],
    SiUsername: '',
    SiName: '',
    SiEmail: '',
    SiCompany: '',
    SiMobile: '',
    SiArea: '',
    SiAddress: '',
    SiDescription: '',
    SiRating: '',
    SiRelationStat: '',
    errorMessage: [],
    modalIsOpenSuccess: false,
    showErrorMessage: false,
    usernameAvailable: true,
    siData: [],
    indianCityWithState: [],
    loader: false,
    SiGST: '',
    snackbarActive: false,
    snackbarMessage: ''
  };
  this.openModal = this.openModal.bind(this);
  this.afterOpenModal = this.afterOpenModal.bind(this);
  this.closeModal = this.closeModal.bind(this);
  this.closeModalSuccess = this.closeModalSuccess.bind(this);

}

openModal() {
  this.setState({modalIsOpen: true});
}    

closeModalSuccess() {
  this.setState({
    modalStateAftereOpenSuccess: 'animated animated-duration-custom slideOutUp',
    modalIsOpen: false
  },()=>{
    setTimeout(()=>{
      this.setState({
        modalIsOpenSuccess: false
      },()=>this.props.closeAllModal())
    }, 500);
  })
}


afterOpenModal() {

}

closeModal() {
  this.setState({
    modalStateAftereOpen: 'animated animated-duration-custom slideOutUp',
    SiUsername: '',
    SiName: '',
    SiEmail: '',
    SiCompany: '',
    SiMobile: '',
    SiArea: '',
    SiAddress: '',
    SiDescription: '',
    SiRating: '',
    SiRelationStat: '',

  },()=>{
    setTimeout(()=>{
      this.setState({
        modalIsOpen: false
      },()=>this.props.closeAllModal())
    }, 500);
  })
}

onSelectChange = (operationMode,valueSelect) => {
  if(operationMode==='rating'){
    this.setState({
      SiRating: valueSelect.value,
      errorMessage: []
    })
  }
  if(operationMode==='relationStat'){
    this.setState({
      SiRelationStat: valueSelect.value,
      errorMessage: []
    })
  }
  if(operationMode==='siArea'){
    this.setState({
      SiArea: valueSelect.value,
      errorMessage: []
    })
  }
}

componentDidMount(){
    this.fecthAllSI();
   let  cityNew = [];
    cities.map((e)=>{
    let newCity = {
       "label" : `${e.city}, ${e.state}`
     }
     cityNew.push(newCity);
    })
    this.setState({
      indianCityWithState: cityNew
    },()=>console.log(this.state.indianCityWithState))   
}

fecthAllSI = ()=>{
  var tokenStored = localStorage.getItem('token');
  tokenStored = `Token ${tokenStored}`;
  var headers = {
    'Content-Type': 'application/json',
    "Access-Control-Allow-Origin": "*",
    'X-CSRFToken': localStorage.getItem('csrftoken'),
    'Authorization': tokenStored
}
  fetch('/cloud/si_IntegratorApi/' ,{
          method: "GET",
          headers: headers,
      })
                   .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
.then(data => {
  this.setState({
    siData: data
  })
})
.catch((err)=>{
  console.log(err)
})
}




AddingSI = () => {
  let si_name = this.state.SiName;
  let si_company = this.state.SiCompany;
  let si_email = this.state.SiEmail;
  let si_mobile = this.state.SiMobile;
  let si_area = this.state.SiArea;
  let si_address = this.state.SiAddress;
  let si_description = this.state.SiDescription;
  let si_rating = this.state.SiRating;
  let si_relationstatus = this.state.SiRelationStat;
  let si_gstin = this.state.SiGST;

  
  var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
  }

    fetch('/cloud/si_IntegratorApi/' ,{
            method: "POST",
            headers: headers,
            body: JSON.stringify({
               si_name,
               si_email,
               si_mobile,
               si_area,
               si_address,
               si_description,
               si_rating,
               si_company,
               si_relationstatus,
               si_gstin
                  })
        })
        .catch(some=>console.log(some))
  .then(response => {
    return response.json()
  })
  .then(data => {
    let rawData = data;
     data=data.data
     let index = Object.keys(data)[0]
    let  errorLog = index + ": " + data[Object.keys(data)[0]]
    if(rawData.message!=="failure"){
      this.setState({
        modalIsOpen:false,
        modalIsOpenSuccess:true,
        loader: false,
      },()=>this.fecthAllSI())
    }else{     
      this.setState({
        loader: false,
        snackbarActive: true,
        snackbarMessage: errorLog
      })      

  }
  })
  .catch((err)=>{
    console.log(err)

  })
  ;
}

AddingAnotherSI = () => {
  let si_name = this.state.SiName;
  let si_company = this.state.SiCompany;
  let si_email = this.state.SiEmail;
  let si_mobile = this.state.SiMobile;
  let si_area = this.state.SiArea;
  let si_address = this.state.SiAddress;
  let si_description = this.state.SiDescription;
  let si_rating = this.state.SiRating;
  let si_relationstatus = this.state.SiRelationStat;
  let si_gstin = this.state.SiGST;
  
  var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
  }

    fetch('/cloud/si_IntegratorApi/' ,{
            method: "POST",
            headers: headers,
            body: JSON.stringify({
               si_name,
               si_email,
               si_mobile,
               si_area,
               si_address,
               si_description,
               si_rating,
               si_company,
               si_relationstatus,
               si_gstin,
                  })
        })
           .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
  .then(data => {
    if(data.message!=="failure"){
      this.setState({
        modalIsOpen:false,
        addAnotherSuccess: true,
        siData: data
      },()=>{
        setTimeout(()=>{
          this.setState({
            addAnotherSuccess:false
          })
        },3000)
        this.setState({
          modalIsOpen:true,
          SiName: '',
          SiCompany: '',
          SiGST: '',
          SiNotes: '',
          SiEmail: '',
          SiMobile: '',
          SiArea: '',
          SiAddress: '',
          SiDescription: '',
          SiRating: '',
          SiRelationStat: '',          
          showErrorMessage: false,
          SiGST: '',
          loader: false,
        },()=>this.fecthAllSI())
      })
    }else{
      alert('SI with same credentials already registered');
      // const history = createHistory({forceRefresh: true})
      window.location.href ='/systemintegrator/system'
  }
  })
  .catch((err)=>{
    console.log(err)

  })
  ;
}



AddSI = () => {
  this.setState({
    showErrorMessage: true
  },()=>{
    this.fetchError((e)=>{
     if(e==='NoError'){
       this.setState({
         loader: true
       },()=>this.AddingSI())       
     }
    })
  })
}

AddAnotherSI = () => {
  this.setState({
    showErrorMessage: true
  },()=>{
    this.fetchError((e)=>{
     if(e==='NoError'){
       this.setState({
        loader: true
      },()=>this.AddingAnotherSI())      
     }
    })
  })
}




checkSIUsername = (e) =>{
  let data = '';
  this.state.siData.forEach((e)=>{
    if(e.si_userName===this.state.SiUsername){
    data = 'username exist';
    }
  })
  if(data==='username exist'){
    this.setState({
      usernameAvailable:false
    })
  }
}

fetchError = (noError) => {
var totalError = 10;

if(ErrorText('notEmpty', this.state.SiName)==='No Error'){
  totalError=totalError-1;
}

if(ErrorText('email', this.state.SiEmail)==='No Error'){
  totalError=totalError-1;
}
if(ErrorText('notEmpty', this.state.SiCompany)==='No Error'){
  totalError=totalError-1;
}
if(ErrorText('isMobile', this.state.SiMobile)==='No Error'){
  totalError=totalError-1;
}
if(ErrorText('notEmpty', this.state.SiAddress)==='No Error'){
  totalError=totalError-1;
}
if(ErrorText('notEmpty', this.state.SiArea)==='No Error'){
  totalError=totalError-1;
}
if(ErrorText('notEmpty', this.state.SiDescription)==='No Error'){
  totalError=totalError-1;
}
if(ErrorText('gst', this.state.SiGST)==='No Error'){
  totalError=totalError-1;
}
if(this.state.SiRelationStat!==''){
  totalError=totalError-1;
}
if(this.state.SiRating!==''){
  totalError=totalError-1;
}
if(totalError===0){
  noError('NoError');
}
}

handleChangeInputBox = (name, event) => {
  this.setState({
    [name]: event
  },()=>{
    if(true){      
      this.checkSIUsername()
        }
  }); 
}
    render(){
        return (
          <React.Fragment>
             <SnackBar open={this.state.snackbarActive} handleSnackbarClose={()=>{    this.setState({
      snackbarActive: false
    })}} message={this.state.snackbarMessage}/>
            {this.state.loader  ? <Loader /> : null}
            <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          className={this.state.modalStateAftereOpen} 
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-add-device">
            <div className="float-right cross-times"  onClick={this.closeModal}>
                <i class="fas fa-timess fa-2x mr-2"></i>
            </div>
          </div>
          <h3 className="modal-heading text-uppercase mb-0" style={{ color: '#888888', fontSize: '30px', }}>Add System Integrator</h3>
          <div className="row">
          {this.state.addAnotherSuccess ? <div class="col-12 my-2 alert alert-success fade show" role="alert">
 Successfully registered the System Integrator.
  <button type="button" class="close" data-dismiss="alert" aria-label="Close">    
  </button>
</div> : null}
          </div>
          <div className="row">     
             <div className="col-6 mx-0 px-0" >
             <InputBox 
               inputText={this.state.SiName}
               error={ErrorText('notEmpty', this.state.SiName)!=='No Error' && this.state.showErrorMessage  ? true : false}
               errorText={ErrorText('notEmpty', this.state.SiName)!=='No Error' && this.state.showErrorMessage ? 'Please enter the SI Name' : ''}
               placeholder="SI Name"
               inputBoxName="SiName"               
               handleChangeCustom={this.handleChangeInputBox.bind(this)}
               textLength={50}
               validate={true}
                 />
             </div>  
             <div className="col-6 mx-0 px-0 ">
             <InputBox 
               inputText={this.state.SiEmail}    
               error={ErrorText('email', this.state.SiEmail)!=='No Error' && this.state.showErrorMessage ? true : false}
               errorText={ErrorText('email', this.state.SiEmail)!=='No Error' && this.state.showErrorMessage ? 'Please enter a valid SI Email' : ''}
               placeholder="SI Email"
               inputBoxName="SiEmail"
               handleChangeCustom={this.handleChangeInputBox.bind(this)}
               textLength={255}/>
             </div>
             <div className="col-6 mx-0 px-0 ">
             <InputBox 
               inputText={this.state.SiCompany}
               error={ErrorText('notEmpty', this.state.SiCompany)!=='No Error' && this.state.showErrorMessage ? true : false}
               errorText={ErrorText('notEmpty', this.state.SiCompany)!=='No Error' && this.state.showErrorMessage ? 'Please enter the SI Company' : ''}
               placeholder="SI Company"
               inputBoxName="SiCompany"
               handleChangeCustom={this.handleChangeInputBox.bind(this)}
               textLength={100}
               validate={true}
               />
             </div>
             <div className="col-6 mx-0 px-0 ">
             <InputBox 
               inputText={this.state.SiMobile}
               error={ErrorText('isMobile', this.state.SiMobile)!=='No Error' && this.state.showErrorMessage ? true : false}
               errorText={ErrorText('isMobile', this.state.SiMobile)!=='No Error' && this.state.showErrorMessage ? 'Please enter a valid SI Mobile of 10 digits' : ''}
               isNumber={true}
               placeholder="SI Mobile"
               inputBoxName="SiMobile"
               handleChangeCustom={this.handleChangeInputBox.bind(this)}
               textLength={10}
               validate={true}
               />
             </div>
             <div className="col-6 mx-0 px-0 ">
             <InputBox 
               inputText={this.state.SiAddress}
               error={ErrorText('notEmpty', this.state.SiAddress)!=='No Error' && this.state.showErrorMessage ? true : false}
               errorText={ErrorText('notEmpty', this.state.SiAddress)!=='No Error' && this.state.showErrorMessage ? 'Please enter the SI Address' : ''}
               placeholder="SI Address"
               inputBoxName="SiAddress"
               handleChangeCustom={this.handleChangeInputBox.bind(this)}
               textLength={255}
               validate={true}
               />
             </div>
             <div className="col-6 mx-0 px-0">
             <InputBox 
               inputText={this.state.SiDescription}
               error={ErrorText('notEmpty', this.state.SiDescription)!=='No Error' && this.state.showErrorMessage ? true : false}
               errorText={ErrorText('notEmpty', this.state.SiDescription)!=='No Error' && this.state.showErrorMessage ? 'Please enter the SI Description' : ''}
               placeholder="SI Description"
               inputBoxName="SiDescription"
               handleChangeCustom={this.handleChangeInputBox.bind(this)}
               textLength={255}
               validate={true}
               />
             </div>
             <div className="col-6  text-field-modal" style={{paddingLeft: '9px',paddingRight: '5px', marginTop: '20px'}} >
              <IntegrationReactSelectNew 
              placeholder=""
              multipleSelect={false}
              content={this.state.indianCityWithState}
              onSelect={this.onSelectChange.bind(this, 'siArea')}
              IntegrationReactSelectNewLabel = "SI Area"
              errorText={this.state.SiArea==='' && this.state.showErrorMessage ? 'Please select the SI Area' : ''}
              />
              </div>
             <div className="col-6 text-field-modal" style={{paddingLeft: '9px',paddingRight: '5px', marginTop: '20px'}} >
              <IntegrationReactSelectNew 
              placeholder=""
              multipleSelect={false}
              content={SiRelationStat}
              onSelect={this.onSelectChange.bind(this,'relationStat')}
              IntegrationReactSelectNewLabel = "Relationship Status"
              errorText={this.state.SiRelationStat==='' && this.state.showErrorMessage ? 'Please select the Relationship Status' : ''}
              />
            </div>           
            <div className="col-6 px-0" style={{marginTop: '19px'}} >
             <InputBox 
               inputText={this.state.SiGST}
               error={ErrorText('gst', this.state.SiGST)!=='No Error' && this.state.showErrorMessage ? true : false}
               errorText={ErrorText('gst', this.state.SiGST)!=='No Error' && this.state.showErrorMessage ? 'Please enter a valid SI GST of 15 characters in format of 29ABCDE1234F2Z5' : ''}
               placeholder="SI GST"
               inputBoxName="SiGST"
               handleChangeCustom={this.handleChangeInputBox.bind(this)}
               textLength={15}
               validate={true}
               isUppercase={true}
               />
             </div>
             <div className="col-6 text-field-modal" style={{marginTop: '30px',paddingLeft: '9px',paddingRight: '5px'}} >
              <IntegrationReactSelectNew 
              placeholder=""
              multipleSelect={false}
              content={SiRating}
              onSelect={this.onSelectChange.bind(this,'rating')}
              IntegrationReactSelectNewLabel = "Rating"
              errorText={this.state.SiRating==='' && this.state.showErrorMessage ? 'Please select the Rating' : ''}
              />
            </div>  
            </div>             
             <div className="float-right" style={{marginTop: '70px', marginRight: '-15px'}}>
             <div className="btn btn-new-grey" style={{marginRight: '15px'}} onClick={this.closeModal}>Cancel</div>
             <div className="btn btn-new-orange" style={{marginRight: '15px'}} onClick={this.AddAnotherSI.bind(this)}>
             Add Another
             </div>  
               <i className="fa fa-star-christmas fa-spin"></i>
               <div className="btn btn-new-green " onClick={this.AddSI.bind(this)}>Add</div>              
             </div>
        </Modal>
        <Modal
                 isOpen={this.state.modalIsOpenSuccess}
                 style={customStylesSuccess}
                 className={this.state.modalStateAftereOpenSuccess}
                  contentLabel="Example Modal">
              <div className="modal-add-device">
                <div className="float-right cross-times" onClick={this.closeModalSuccess}>
                  <i className="fas   fa-2x mr-2"></i>
                </div>
              </div>
            <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">SI Added Successfully</h3>
                <i class="fas fa-check-circle update"></i>
                <br/>
                <div className="btn btn-new-grey"
                  onClick={this.closeModalSuccess}>
                              Close 
                            </div>
            </div>
            </Modal> 
          </React.Fragment>
        );
    }
}
